import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  alpha,
} from "@mui/material";

export interface StatCardProps {
  title: string;
  count: number | undefined;
  icon: React.ReactNode;
  color: string;
  onClick?: () => void;
  emptyLabel?: string;
}

export function StatCard({
  title,
  count,
  icon,
  color,
  onClick,
  emptyLabel = "-",
}: StatCardProps) {
  return (
    <Card
      sx={{
        height: "100%",
        cursor: onClick ? "pointer" : "default",
        "&:hover": onClick ? { transform: "translateY(-2px)" } : {},
        transition: "transform 0.2s ease",
      }}
      onClick={onClick}
    >
      <CardContent
        sx={{ display: "flex", alignItems: "center", gap: 2.5, py: 3 }}
      >
        <Avatar
          sx={{
            bgcolor: alpha(color, 0.12),
            color,
            width: 56,
            height: 56,
          }}
        >
          {icon}
        </Avatar>
        <Box>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              lineHeight: 1.1,
            }}
          >
            {count ?? emptyLabel}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mt: 0.5,
            }}
          >
            {title}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
